var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWpp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170.1 51",
    style: {
      enableBackground: "new 0 0 170.1 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#191D63;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.2,24.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C113.8,24.9,113.1,24.1,112.2,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.2,14.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S113.1,14.5,112.2,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.2,19.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S113.1,19.3,112.2,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.4,7.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S117.3,7.2,116.4,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.4,3c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S116.9,3,116.4,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.2,32.2c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6C110.6,31.5,111.3,32.2,112.2,32.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.2,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S113.1,9.6,112.2,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S108.9,26.6,108,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108,24.4c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1S107.4,24.4,108,24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,24.4c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1S99.1,24.4,99.6,24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.8,36.5c0.6,0,1-0.5,1-1s-0.5-1-1-1c-0.6,0-1,0.5-1,1S103.3,36.5,103.8,36.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108,12.7c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C109,13.1,108.6,12.7,108,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,12.7c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C100.6,13.1,100.2,12.7,99.6,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.2,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S113.1,4.8,112.2,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.2,0.6c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C113.2,1,112.7,0.6,112.2,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108,34.7c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6S107.1,34.7,108,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.4,16.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C118,17.6,117.3,16.9,116.4,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,12.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C136.6,12.8,135.9,12.1,135,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,7.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S135.9,7.2,135,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.6,19.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C122.2,20,121.5,19.3,120.6,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,2.4c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S135.9,2.4,135,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S135.9,26.6,135,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,21.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C136.6,22.5,135.9,21.7,135,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,16.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S135.9,16.9,135,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,21.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C92.9,22.5,92.1,21.7,91.2,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.4,29.8c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6C114.7,29.1,115.5,29.8,116.4,29.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.6,14.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C122.2,15.2,121.5,14.5,120.6,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108,7.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S108.9,7.2,108,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.4,21.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C118,22.5,117.3,21.7,116.4,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.6,26.8c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1s-1,0.5-1,1S120,26.8,120.6,26.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.6,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S121.5,9.6,120.6,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,33.8c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C97.1,34.5,96.3,33.8,95.4,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,14.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6S97,17,97,16.1C97.1,15.2,96.3,14.5,95.4,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108,2.4c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S108.9,2.4,108,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6S97,7.3,97,6.4C97.1,5.5,96.3,4.8,95.4,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,0c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6S97,2.5,97,1.6S96.3,0,95.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,29c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C97.1,29.7,96.3,29,95.4,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,24.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C97.1,24.9,96.3,24.1,95.4,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,19.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C97.1,20,96.3,19.3,95.4,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,31.4c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S92.1,31.4,91.2,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,36.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C92.9,37,92.1,36.2,91.2,36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,51c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1S94.9,51,95.4,51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C92.9,27.3,92.1,26.6,91.2,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,31.4c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S135.9,31.4,135,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,41.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C92.9,41.8,92.1,41.1,91.2,41.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,49.2c0.9,0,1.6-0.7,1.6-1.6S92.1,46,91.2,46s-1.6,0.7-1.6,1.6C89.6,48.4,90.3,49.2,91.2,49.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S96.3,9.6,95.4,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.8,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S104.7,4.8,103.8,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.8,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S104.7,9.6,103.8,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.8,0c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S104.7,0,103.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,34.7c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6S98,32.2,98,33.1S98.7,34.7,99.6,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,38.7c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C97.1,39.4,96.3,38.7,95.4,38.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.8,24.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C105.4,24.9,104.7,24.1,103.8,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.8,32.2c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6S102.9,32.2,103.8,32.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,7.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S100.5,7.2,99.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,2.4C98.7,2.4,98,3.1,98,4c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C101.3,3.1,100.5,2.4,99.6,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,43.5c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6S97,46,97,45.1C97.1,44.2,96.3,43.5,95.4,43.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C101.3,27.3,100.5,26.6,99.6,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.4,12.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C118,12.8,117.3,12.1,116.4,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.9,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C157.5,5.5,156.8,4.8,155.9,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.9,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S156.8,9.6,155.9,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.9,29c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C157.5,29.7,156.8,29,155.9,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.9,24.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C157.5,24.9,156.8,24.1,155.9,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.1,2.4c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C161.7,3.1,161,2.4,160.1,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.1,12.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C161.7,12.8,161,12.1,160.1,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.1,16.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C161.7,17.6,161,16.9,160.1,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.1,7.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S161,7.2,160.1,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.7,7.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S152.6,7.2,151.7,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.9,0.6c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C156.9,1,156.5,0.6,155.9,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.7,12.7c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C152.7,13.1,152.3,12.7,151.7,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.7,22.3c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S152.3,22.3,151.7,22.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.9,34.4c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S156.5,34.4,155.9,34.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.7,2.4c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S152.6,2.4,151.7,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.7,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S152.6,26.6,151.7,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.7,34.7c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6S150.8,34.7,151.7,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.5,36.5c0.6,0,1-0.5,1-1s-0.5-1-1-1c-0.6,0-1,0.5-1,1S147,36.5,147.5,36.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.5,7.8c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S169,7.8,168.5,7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.3,31.6c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1C163.3,31.2,163.7,31.6,164.3,31.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.1,34c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1C159.1,33.6,159.5,34,160.1,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.5,15.3c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 C166.8,14.6,167.6,15.3,168.5,15.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.5,21.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C170.1,22.5,169.4,21.7,168.5,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.5,16.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S169.4,16.9,168.5,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.3,24.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C165.9,24.9,165.2,24.1,164.3,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.3,19.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S165.2,19.3,164.3,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.1,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C161.7,27.3,161,26.6,160.1,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.3,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S165.2,4.8,164.3,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.3,14.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S165.2,14.5,164.3,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.1,21.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C161.7,22.5,161,21.7,160.1,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.3,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S165.2,9.6,164.3,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,24.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C140.8,24.9,140.1,24.1,139.2,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,36.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C136.6,37,135.9,36.2,135,36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,29c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S140.1,29,139.2,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.5,29c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C149.2,29.7,148.4,29,147.5,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,43.5c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S140.1,43.5,139.2,43.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,33.8c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C140.8,34.5,140.1,33.8,139.2,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,14.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S140.1,14.5,139.2,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,38.7c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S140.1,38.7,139.2,38.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S140.1,4.8,139.2,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,51c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1C138.1,50.5,138.6,51,139.2,51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,49.2c0.9,0,1.6-0.7,1.6-1.6S135.9,46,135,46c-0.9,0-1.6,0.7-1.6,1.6C133.3,48.4,134.1,49.2,135,49.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,41.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S135.9,41.1,135,41.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S140.1,9.6,139.2,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,0c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S140.1,0,139.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.3,2.4c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C145,3.1,144.2,2.4,143.3,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,19.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S140.1,19.3,139.2,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.5,0c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S148.4,0,147.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.5,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C149.2,5.5,148.4,4.8,147.5,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.3,49.2c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6C141.7,48.4,142.4,49.2,143.3,49.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.5,24.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C149.2,24.9,148.4,24.1,147.5,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.3,41.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C145,41.8,144.2,41.1,143.3,41.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.5,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S148.4,9.6,147.5,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.3,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C145,27.3,144.2,26.6,143.3,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.3,21.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C145,22.5,144.2,21.7,143.3,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.3,16.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C145,17.6,144.2,16.9,143.3,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.3,12.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C145,12.8,144.2,12.1,143.3,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.3,7.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S144.2,7.2,143.3,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.3,31.4c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S144.2,31.4,143.3,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.3,36.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C145,37,144.2,36.2,143.3,36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.3,3c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S76.9,3,76.3,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,29c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S31.2,29,30.3,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,24.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S31.2,24.1,30.3,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,15.1c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C31.3,15.5,30.8,15.1,30.3,15.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,19.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S31.2,19.3,30.3,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,34c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1C33.4,33.6,33.9,34,34.5,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,33.8c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C31.9,34.5,31.2,33.8,30.3,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,41.9c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6C28.6,41.2,29.4,41.9,30.3,41.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.1,49.2c0.9,0,1.6-0.7,1.6-1.6S27,46,26.1,46s-1.6,0.7-1.6,1.6C24.4,48.4,25.2,49.2,26.1,49.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.1,31.4c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S27,31.4,26.1,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,38.7c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C23.5,39.4,22.8,38.7,21.9,38.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,43.5c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C23.5,44.2,22.8,43.5,21.9,43.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.1,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S27,26.6,26.1,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.1,41.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S27,41.1,26.1,41.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.1,36.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C27.7,37,27,36.2,26.1,36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.6,27.4c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6S37,24.9,37,25.8S37.7,27.4,38.6,27.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.6,19.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C40.3,20,39.5,19.3,38.6,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.6,14.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C40.3,15.2,39.5,14.5,38.6,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.6,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S39.5,9.6,38.6,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,34c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1C41.8,33.6,42.3,34,42.8,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,7.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S43.7,7.2,42.8,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,7.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S35.4,7.2,34.5,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.6,4.8c-0.9,0-1.6,0.7-1.6,1.6C37,7.3,37.7,8,38.6,8s1.6-0.7,1.6-1.6C40.3,5.5,39.5,4.8,38.6,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,12.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C36.1,12.8,35.4,12.1,34.5,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,21.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C36.1,22.5,35.4,21.7,34.5,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,16.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C36.1,17.6,35.4,16.9,34.5,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C36.1,27.3,35.4,26.6,34.5,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.6,0.6c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C39.7,1,39.2,0.6,38.6,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,3c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S35,3,34.5,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,3c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S43.4,3,42.8,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,10.5c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6C8.5,7.3,7.8,8,7.8,8.9C7.8,9.7,8.5,10.5,9.4,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S14.4,4.8,13.5,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S14.4,9.6,13.5,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,19.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S14.4,19.3,13.5,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,14.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S14.4,14.5,13.5,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,20.2c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6C7.8,19.4,8.5,20.2,9.4,20.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,12.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C44.5,12.8,43.7,12.1,42.8,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,15.3c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6C7.8,14.6,8.5,15.3,9.4,15.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,0c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S14.4,0,13.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,4.8c-0.9,0-1.6,0.7-1.6,1.6C3.6,7.3,4.3,8,5.2,8c0.9,0,1.6-0.7,1.6-1.6C6.9,5.5,6.1,4.8,5.2,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,0C4.3,0,3.6,0.7,3.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S6.1,0,5.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,3C0.4,3,0,3.5,0,4c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C2.1,3.5,1.6,3,1,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S6.1,9.6,5.2,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,2.4C8.5,2.4,7.8,3.1,7.8,4c0,0.9,0.7,1.6,1.6,1.6C10.3,5.6,11,4.9,11,4C11,3.1,10.3,2.4,9.4,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,31.6c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1C12.5,31.2,13,31.6,13.5,31.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,7.8c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S18.3,7.8,17.7,7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,51c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1S21.3,51,21.9,51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,19.9c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S22.4,19.9,21.9,19.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,15.1c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C22.9,15.5,22.4,15.1,21.9,15.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,15.1c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C56.4,15.5,56,15.1,55.4,15.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.1,22.3c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S26.6,22.3,26.1,22.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,22.3c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S51.8,22.3,51.2,22.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,31.4c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C19.3,32.1,18.6,31.4,17.7,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,36.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C19.3,37,18.6,36.2,17.7,36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,24.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S14.4,24.1,13.5,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,24.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S22.8,24.1,21.9,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,29c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C23.5,29.7,22.8,29,21.9,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,33.8c-0.9,0-1.6,0.7-1.6,1.6S21,37,21.9,37c0.9,0,1.6-0.7,1.6-1.6C23.5,34.5,22.8,33.8,21.9,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,12.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C19.3,12.8,18.6,12.1,17.7,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S18.6,26.6,17.7,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,43.7c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1C16.7,43.3,17.1,43.7,17.7,43.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,21.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C19.3,22.5,18.6,21.7,17.7,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,16.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S18.6,16.9,17.7,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,43.7c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1s-1,0.5-1,1C58.6,43.3,59,43.7,59.6,43.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68,12.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C69.6,12.8,68.9,12.1,68,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68,7.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S68.9,7.2,68,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68,20.2c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6C66.3,19.4,67.1,20.2,68,20.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.2,12.9c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6S71.3,12.9,72.2,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68,2.4c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C69.6,3.1,68.9,2.4,68,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.2,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S73.1,4.8,72.2,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.2,0c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S73.1,0,72.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.8,19.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S64.7,19.3,63.8,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.8,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S64.7,9.6,63.8,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.8,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S64.7,4.8,63.8,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.8,0c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S64.7,0,63.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,51c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1C86,50.5,86.5,51,87.1,51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.8,31.6c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1C62.8,31.2,63.2,31.6,63.8,31.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.8,24.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S64.7,24.1,63.8,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.8,14.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S64.7,14.5,63.8,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,33.8c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C88.7,34.5,88,33.8,87.1,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,43.5c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S88,43.5,87.1,43.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,38.7c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S88,38.7,87.1,38.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,2.4c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C92.9,3.1,92.1,2.4,91.2,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,7.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S92.1,7.2,91.2,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,12.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C92.9,12.8,92.1,12.1,91.2,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,19.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S88,19.3,87.1,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,29c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S88,29,87.1,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,14.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S88,14.5,87.1,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S88,4.8,87.1,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,9.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S88,9.6,87.1,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,0c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6S88,0,87.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,24.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C88.7,24.9,88,24.1,87.1,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,16.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C44.5,17.6,43.7,16.9,42.8,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S52.1,26.6,51.2,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,33.8c-0.9,0-1.6,0.7-1.6,1.6S46.1,37,47,37s1.6-0.7,1.6-1.6C48.7,34.5,47.9,33.8,47,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,51c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1S54.8,51,55.4,51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,31.4c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S52.1,31.4,51.2,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,49.2c0.9,0,1.6-0.7,1.6-1.6S52.1,46,51.2,46s-1.6,0.7-1.6,1.6C49.6,48.4,50.3,49.2,51.2,49.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,36.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C52.8,37,52.1,36.2,51.2,36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,41.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S52.1,41.1,51.2,41.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,41.9c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S46.1,41.9,47,41.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,15.1c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C48,15.5,47.6,15.1,47,15.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C44.5,27.3,43.7,26.6,42.8,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,21.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C44.5,22.5,43.7,21.7,42.8,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,29c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C48.7,29.7,47.9,29,47,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,19.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C48.7,20,47.9,19.3,47,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,24.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S47.9,24.1,47,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,21.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C61.2,22.5,60.5,21.7,59.6,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,16.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S60.5,16.9,59.6,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,36.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C61.2,37,60.5,36.2,59.6,36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,19.9c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1S56,19.9,55.4,19.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,31.4c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S60.5,31.4,59.6,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,26.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S60.5,26.6,59.6,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,7.8c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1s1-0.5,1-1S60.1,7.8,59.6,7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,12.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C61.2,12.8,60.5,12.1,59.6,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,29c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S56.3,29,55.4,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,24.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S56.3,24.1,55.4,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,33.8c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C57,34.5,56.3,33.8,55.4,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,16.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C92.9,17.6,92.1,16.9,91.2,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,38.7c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S56.3,38.7,55.4,38.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,43.5c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6S57,46,57,45.1S56.3,43.5,55.4,43.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpp);
export default __webpack_public_path__ + "static/media/WPP.1769fc738fa7bcb725bbfc803ea91388.svg";
export { ForwardRef as ReactComponent };